export default __webpack_public_path__ + "static/media/tailor.e44d3841.jpg";